import { useQuery } from "@tanstack/react-query";
import collectionApiClient, { CollectionCode } from "../../../api/collection";

const FIVE_DAYS_MS = 5 * 24 * 60 * 60 * 1000;

const useUnusedShopifyCodesQuery = () => {
  return useQuery<CollectionCode[]>({
    queryKey: ["unusedShopifyCodes"],
    queryFn: async () => {
      const codes = await collectionApiClient.getCollectionCodes({
        query: "",
        limit: 100,
        populateOrder: true,
        filter: {
          createdBy: "shopify-webhook",
          clockId: null,
          $or: [
            { usedAt: { $size: 0 } },
            { usedAt: { $exists: false } },
            { usedAt: null },
          ],
        },
      });
      const threshold = new Date(Date.now() - FIVE_DAYS_MS);
      return codes.filter((code) => new Date(code.createdAt) <= threshold);
    },
  });
};

export default useUnusedShopifyCodesQuery;
